//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mpi from "../../../plugins/merge";

export default {
  props: {
    info: {
      type: Object,
      default() {
        return {}
      }
    },
    boxColor: {
      type: Array,
      default() {
        return []
      }
    },
    total: {
      type: String,
      default() {
        return '0'
      }
    },
  },
  data() {
    return {
      characterLimit: 10,
      text: '',
    }
  },
  methods: {
    async changeBox(val) {
      if (val.out_of_stock) {
        return;
      }
      if (this.info.theme.id === this.constProductThemes().package) {
        const t = this.$route.query.configId.split('-');
        if (t[1] !== val.value) {
          t[1] = val.value;
          const query = {...this.$route.query, configId: t.join('-')};
          await this.$router.replace({query});
        }
      } else {
        if (this.box.color !== val.name) {
          const query = {...this.$route.query, bc: val.name};
          await this.$router.replace({query});
        }
      }
      this.$emit('updateCanvas');
    },
    async changeQuery() {
      document.querySelector('#initials').blur();
      document.querySelector('#initials').focus();
      const query = {...this.$route.query, bt: this.text};
      await this.$router.replace({query});
      this.$emit('updateCanvas');
    },
    async back() {
      /*mpi.init();
      const image = await mpi.getMergedImage('#box-text');
      try {
        if (image) {
          // console.log(image);
          this.$parent.$emit('changeImage', image)
        }
        this.$parent.$emit('changeStage', this.info.theme.id !== this.constProductThemes().package ? 'configuration-edit' : 'configurator')
      } catch (e) {

      }*/
      this.$parent.$emit('changeStage', 'configuration-edit')
    },
    async close() {
      /*mpi.init();
      const image = await mpi.getMergedImage('#box-text');
      try {
        if (image) {
          this.$parent.$emit('changeImage', image)
        }
        this.$parent.$emit('changeStage', 'configurator')
      } catch (e) {

      }*/
      this.$parent.$emit('changeStage', 'configurator')
    }
  },
  computed: {
    box() {
      let box = '';
      if (this.info.theme.id === this.constProductThemes().package) {
        box = this.boxColor.find(item => item.value === this.$route.query.configId.split('-')[1]) || '';
      } else {
        box = this.boxColor.find(item => item.name === this.$route.query.bc) || '';
      }
      return {
        text: this.$route.query.bt || '',
        box: box,
      }
    },
    description() {
      return this.info?.theme?.id === this.constProductThemes().package ? this.info?.short_description : this.info?.package?.description;
    },
  },
  mounted() {
    this.text = this.$route.query.bt
  }
}
